import { startOfDay } from 'date-fns'
import { toColor } from '../../../utils/ColorTransformator'
import { dateWithoutOffsert } from '../../License/mappers/mapResponseToLicense'

export default function(event) {
  if (event.savedColor) {
    event.customColor = toColor(event.savedColor)
  }
  event.finishDate = startOfDay(dateWithoutOffsert(new Date(event.finishDate)))
  event.startDate = startOfDay(dateWithoutOffsert(new Date(event.startDate)))
  event.provisionDate = event.provisionDate
    ? startOfDay(dateWithoutOffsert(new Date(event.provisionDate)))
    : undefined
  event.paymentOnPlaceDate = event.paymentOnPlaceDate
    ? startOfDay(dateWithoutOffsert(new Date(event.paymentOnPlaceDate)))
    : undefined
  event.dateToPayAfterStart = event.dateToPayAfterStart
    ? startOfDay(dateWithoutOffsert(new Date(event.dateToPayAfterStart)))
    : undefined
  event.dateToPay = event.dateToPay
    ? startOfDay(dateWithoutOffsert(new Date(event.dateToPay)))
    : undefined

  Object.defineProperty(event, 'bookingPrice', {
    get: function() {
      return this._bookingPrice
    },
  })
  Object.defineProperty(event, 'localTax', {
    get: function() {
      return this._localTax
    },
  })
  Object.defineProperty(event, 'paymentOnPlace', {
    get: function() {
      return this._price - this._provision
    },
  })
  Object.defineProperty(event, 'price', {
    get: function() {
      return this._price
    },
  })
  Object.defineProperty(event, 'pricePerDay', {
    get: function() {
      return this._pricePerDay
    },
  })
  Object.defineProperty(event, 'provision', {
    get: function() {
      return this._provision
    },
  })
  Object.defineProperty(event, 'deposit', {
    get: function() {
      return this._deposit
    },
  })

  return event
}
